export class widgetStatistics {

  static sendPresentationStatisticsEvent(tabName: string, name: string, isWidgetPresented, type) {
      const label = [
        'type:' + type,
        'name:' + name,
        'tab:' + tabName,
        'visible:' + isWidgetPresented
      ].join('###');

      return this.__trackShow(label);

  }

  static sendUserRedirectionStatisticsEvent(clickedArea: string, type: string, name:string, tabName: string, clickType: string, redirectionUrl: string) {
      const label = [
        'clickedArea:' + clickedArea,
        'type:' + type,
        'name:' + name,
        'tab:' + tabName,
        'clickType:' + clickType, //right, left, Enter
        redirectionUrl ? 'openUrl:' + redirectionUrl : ''
      ].join('###');

      return this.__trackClick(label);
  }

  private static __trackClick(label) {
      return {
        category: 'widget-offsite-search-results',
        action: 'click',
        label: label
      };
  }

  private static __trackShow(label) {
      return {
        category: 'widget-offsite-search-results',
        action: 'show',
        label: label
      };
  }
}
